module.exports = require("vue-the-mask");